/**
 * Created by gzk on 2017-10-08.
 */
import {Injectable} from "@angular/core";
import {ActionSheetController} from "ionic-angular";
import {NoticeService} from "./notice-service";
import {FileTransfer, FileTransferObject, FileUploadOptions} from "@ionic-native/file-transfer";
import {Camera, CameraOptions} from "@ionic-native/camera";
import {ImagePicker} from "@ionic-native/image-picker";
import {Md5} from "ts-md5/dist/md5";
import {File} from '@ionic-native/file';

declare var window;
declare var cordova;

@Injectable()
export class ImgService {

  // 参考：https://github.com/driftyco/ionic-native/blob/master/src/plugins/camera.ts
  // 调用相机时传入的参数
  private cameraOpt: CameraOptions = {
    quality: 50,
    destinationType: 1, // Camera.DestinationType.FILE_URI,
    sourceType: 1, // Camera.PictureSourceType.CAMERA,
    encodingType: 0, // Camera.EncodingType.JPEG,
    mediaType: 0, // Camera.MediaType.PICTURE,
    allowEdit: true,
    correctOrientation: true
  };

  // 调用相册时传入的参数
  private imagePickerOpt = {
    maximumImagesCount: 1,//选择一张图片
    width: 800,
    height: 800,
    quality: 80
  };

  //imgPath: string = ''; //图片路径
  fileTrans: FileTransferObject;

  upload: any = {
    url: 'http://v0.api.upyun.com/wanshidingdang',           //接收图片的url
    fileKey: 'image',  //接收图片时的key
    headers: {
      'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8' //不加入 发生错误！！
    },
    params: {},        //需要额外上传的参数
    success: (data) => {
    }, //图片上传成功后的回调
    error: (err) => {
    },   //图片上传失败后的回调
    listen: () => {
    }   //监听上传过程
  };

  constructor(private actionSheetCtrl: ActionSheetController,
              private noticeSer: NoticeService,
              public camera: Camera,
              private file: File,
              public  transfer: FileTransfer,
              public imagepicker: ImagePicker) {

    this.cameraOpt = {
      quality: 50,
      destinationType: this.camera.DestinationType.FILE_URI,
      sourceType: this.camera.PictureSourceType.CAMERA,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      allowEdit: true,
      correctOrientation: true
    };

  }

/*
  public getImageInfo(fileUrlPath) {
    // fileUrlPath = image url : " + file.nativeURL
    window.resolveLocalFileSystemURL(fileUrlPath, (fileEntry) => {

      fileEntry.getMetadata((metadata) => {
        console.log("image size : " + metadata.size);
        console.log("image date : " + metadata.modificationTime);
      });

      fileEntry.file(function (fileObject) {
        var reader = new FileReader();
        reader.onloadend = function (evt) {
          var image = new Image();
          image.onload = function (evt) {
            console.log("image resolution: " + this["width"] + " x " + this["height"]);
            image = null
          }
          image.src = evt.target["result"];
        }
        reader.readAsDataURL(fileObject)
      }, function () {
        console.error("There was an error reading or processing this file.")
      })
    }, (error) => {
      console.error(error);
    });

  }
*/

  showPicActionSheet2() {
    let actionSheet = this.actionSheetCtrl.create({
      title: '选择',
      buttons: [
        {
          text: '拍照',
          handler: () => {
            this.startCamera();
          }
        },
        {
          text: '从手机相册选择',
          handler: () => {
            this.multiImagePicker(6);
          }
        },
        {
          text: '取消',
          role: 'cancel',
          handler: () => {

          }
        }
      ]
    });
    actionSheet.present();
  }

  showPicActionSheet() {
    this.useASComponent();
  }

  // 使用ionic中的ActionSheet组件
  private useASComponent() {
    let actionSheet = this.actionSheetCtrl.create({
      title: '选择',
      buttons: [
        {
          text: '拍照',
          handler: () => {
            this.startCamera();
          }
        },
        {
          text: '从手机相册选择',
          handler: () => {
            this.openImgPicker();
          }
        },
        {
          text: '取消',
          role: 'cancel',
          handler: () => {

          }
        }
      ]
    });
    actionSheet.present();
  }

  // 使用原生的ActionSheet组件
  /*private useNativeAS() {
   let buttonLabels = ['拍照', '从手机相册选择'];
   ActionSheet.show({
   'title': '选择',
   'buttonLabels': buttonLabels,
   'addCancelButtonWithLabel': 'Cancel',
   //'addDestructiveButtonWithLabel' : 'Delete'
   }).then((buttonIndex: number) => {
   if(buttonIndex == 1) {
   this.startCamera();
   } else if(buttonIndex == 2) {
   this.openImgPicker();
   }
   });
   }*/

  // 手机相册单图选择
  public singleImagePicker() {
    let temp = '';
    let singleImagePickerOpt = {
      maximumImagesCount: 1,//选择一张图片 最多上传张数
      width: 800,
      height: 800,
      quality: 80
    };

    this.imagepicker.getPictures(singleImagePickerOpt)
      .then((results) => {
        // for (let i = 0; i < results.length; i++) {
        //   temp = results[i];
        // }
        temp = results[0]; // 一张图上传
        console.log(temp);
        // 截图
        // this.imageCrop.crop(temp, {quality: 75, targetHeight: 320, targetWidth: 320}).then(
        //   newImage => {
        //     console.log('new image path is: ' + newImage);
        //     this.uploadImg(newImage);
        //
        //   }, error => {
        //     console.error('Error cropping image', error)
        //   }
        // );
      }, (err) => {
        this.noticeSer.showToast('ERROR:' + err); //错误：无法从手机相册中选择图片！
      });
  }

  // 手机相册多图选择
  public multiImagePicker(maximumImagesCount) {
    let temp = '';

    let multiImagePickerOpt = {
      maximumImagesCount: maximumImagesCount,//选择一张图片 最多上传张数
      width: 800,
      height: 800,
      quality: 80
    };

    this.imagepicker.getPictures(multiImagePickerOpt)
      .then((results) => {
        for (let i = 0; i < results.length; i++) {
          temp = results[i];
          this.uploadImg(temp);
        }

        // this.uploadImg(temp);

      }, (err) => {
        this.noticeSer.showToast('ERROR:' + err); //错误：无法从手机相册中选择图片！
      });
  }


  // 启动拍照功能
  private startCamera() {
    this.camera.getPicture(this.cameraOpt).then((imageData) => {

      this.uploadImg(imageData);

    }, (err) => {
      this.noticeSer.showToast('ERROR:' + err); //错误：无法使用拍照功能！
    });
  }

  // 打开手机相册
  private openImgPicker() {
    let temp = '';
    this.imagepicker.getPictures(this.imagePickerOpt)
      .then((results) => {
        for (let i = 0; i < results.length; i++) {
          temp = results[i];
        }

        this.uploadImg(temp);

      }, (err) => {
        this.noticeSer.showToast('ERROR:' + err); //错误：无法从手机相册中选择图片！
      });

    /*let str = '{"status":1,"msg":"提示：图片上传成功！","data":"http:\/\/192.168.1.20\/image\/580af6bcc4d40580af6bcc4d45.jpg"}';
     let res = JSON.parse(str);
     this.upload.success(res);*/
  }


  private getPolicy() {
    let time = new Date().getTime();
    let params: any = {
      'bucket': 'wanshidingdang',
      'save-key': '/andriod/' + time + '.jpg',
      'service': 'wanshidingdang',
      'expiration': time + 24 * 60 * 60
    };
    let policy = JSON.stringify(params);
    policy = Base64.encode(policy);
    return policy.toString();
  }

  private getBodySignature(policy: string) {
    let signature: string = Md5.hashStr(policy + '&p04SeyUgHnHnsDLk8qkhTrBsltQ=').toString();
    return signature;

  }


  // 上传图片
  uploadImg(path: string) {
    if (!path) {
      return;
    }
    this.fileTrans = this.transfer.create();

    let policy = this.getPolicy();
    let signature = this.getBodySignature(policy);
    let options: FileUploadOptions =
      {
        fileKey: 'file',
        fileName: 'name.jpg',  // 文件类型
        headers: {},
        params: {
          'file': 'ddd.jpg',
          'policy': policy,
          'signature': signature
        }    // 如果要传参数，写这里
      };


    console.log(options);

    this.fileTrans.upload(path, this.upload.url, options)
      .then((data) => {

        console.log(data);

        if (this.upload.success) {
          this.upload.success(JSON.parse(data.response));
        }

      }, (err) => {

        console.log(err);
        if (this.upload.error) {
          this.upload.error(err);
        } else {
          this.noticeSer.showToast('错误：上传失败！');
        }
      });
  }

  // 停止上传
  stopUpload() {
    if (this.fileTrans) {
      this.fileTrans.abort();
    }
  }
}

class Base64 {
  // private property
  static _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

  // public method for encoding
  public static encode(input) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = this.utf8_encode(input);
    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;
      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }
      output = output +
        this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
        this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
    }
    return output;
  }

  // private method for UTF-8 encoding
  public static utf8_encode(string) {
    string = string.replace(/\r\n/g, "\n");
    var utftext = "";
    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n);
      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if ((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      } else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }
    }
    return utftext;
  }

}



// WEBPACK FOOTER //
// ./src/providers/api-service/img-service.ts